import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';

export const getActiveAuctions = async (groupId) => {
  try {
    const getActiveAuctionsFn = httpsCallable(functions, 'getActiveAuctionsByGroupV2');
    const result = await getActiveAuctionsFn({ groupId });

    if (result.data.success === 'yes') {
      return {
        docs: result.data.data.map((auction) => ({
          id: auction.id,
          data: () => auction,
        })),
      };
    } else {
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error getting active auctions:', error);
    return { success: 'no', message: error.message };
  }
};
